import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import type { IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { LifeCycle, ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { translationsService } from './translationsService'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { translationsUpdateHandler } from './translationsUpdateHandler'
import { translationsServicePageWillMount } from './translationsServicePageWillMount'

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(translationsService)
	bind<IPageWillMountHandler>(LifeCycle.PageWillMountHandler).to(translationsServicePageWillMount)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	page(bind)
	bind(ModelUpdatesHandlersImplementor).to(translationsUpdateHandler)
}
